var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "div",
        { staticClass: "row-data tdi-toolbar-card" },
        [
          _c("div", { staticClass: "tdi-card-head" }, [
            _vm._m(0),
            _c(
              "div",
              {
                staticClass: "button-click row-data",
                staticStyle: { "margin-bottom": "0" },
              },
              [
                _vm.checkPermission(["studentQuality_menu_update"])
                  ? _c(
                      "el-dropdown",
                      { on: { command: _vm.handleCommandAdd } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              "border-radius": "18px",
                              "margin-right": "10px",
                            },
                            attrs: { type: "success" },
                          },
                          [
                            _c("i", { staticClass: "el-icon-plus" }),
                            _vm._v(" Thêm mới\n          "),
                          ]
                        ),
                        _c(
                          "el-dropdown-menu",
                          { staticClass: "el-dropdown-menu-container" },
                          [
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "createClassMenu" } },
                              [_vm._v("Nhập Thực Đơn")]
                            ),
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "createClassMenuFile" } },
                              [_vm._v("Thêm dạng File,Ảnh")]
                            ),
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "createClassMenuExcel" } },
                              [_vm._v("Thực đơn từ Excel")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-dropdown",
                  { on: { command: _vm.handleCommandAction } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { "border-radius": "18px" },
                        attrs: { type: "primary" },
                      },
                      [
                        _vm._v("\n            Tác vụ "),
                        _c("i", { staticClass: "el-icon-caret-bottom" }),
                      ]
                    ),
                    _c(
                      "el-dropdown-menu",
                      { staticClass: "el-dropdown-menu-container" },
                      [
                        _vm.checkPermission(["studentQuality_menu_update"])
                          ? _c(
                              "span",
                              [
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { command: "activeAccount" } },
                                  [_vm._v("Duyệt Thực Đơn")]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { command: "unActiveAccount" } },
                                  [_vm._v("Hủy Duyệt Thực Đơn")]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: "deleteContentClassMenu",
                                    },
                                  },
                                  [_vm._v("Xóa Nội Dung Thực Đơn")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "exportExcel" } },
                          [_vm._v("Xuất File Excel")]
                        ),
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "exportExcelStatistics" } },
                          [_vm._v("Thống kê thực đơn")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-form",
            {
              staticClass: "tdi-form-grid",
              attrs: { "label-position": "top" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "tdi-form-item",
                  attrs: { label: "Chế độ xem" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "custom-radio-pill",
                      attrs: { size: "medium" },
                      on: { change: _vm.handleRadio },
                      model: {
                        value: _vm.radio,
                        callback: function ($$v) {
                          _vm.radio = $$v
                        },
                        expression: "radio",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "1" } }, [
                        _vm._v("Xem Thực Đơn"),
                      ]),
                      _c("el-radio-button", { attrs: { label: "2" } }, [
                        _vm._v("Chi tiết"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.radio === "1"
                ? [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "tdi-form-item",
                        attrs: { label: "Chọn tuần" },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "240px" },
                          attrs: {
                            type: "week",
                            "value-format": "yyyy-MM-dd",
                            format: "Tuần WW(từ dd-MM-yyyy)",
                            placeholder: "Chọn tuần",
                            clearable: false,
                          },
                          on: { change: _vm.searchByProperties },
                          model: {
                            value: _vm.timeClassMenu,
                            callback: function ($$v) {
                              _vm.timeClassMenu = $$v
                            },
                            expression: "timeClassMenu",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.getAppTypeUserLogin === "plus"
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "tdi-form-item",
                            attrs: { label: "Chọn khối" },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "160px" },
                                attrs: {
                                  placeholder: "Chọn khối",
                                  clearable: true,
                                },
                                on: { change: _vm.changeGrade },
                                model: {
                                  value: _vm.dataSearch.idGrade,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataSearch, "idGrade", $$v)
                                  },
                                  expression: "dataSearch.idGrade",
                                },
                              },
                              _vm._l(_vm.gradeOfSchoolList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.gradeName,
                                    value: item.id,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "tdi-form-item",
                        attrs: { label: "Chọn lớp" },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "160px" },
                            attrs: { placeholder: "Chọn lớp", clearable: true },
                            on: {
                              change: function ($event) {
                                return _vm.searchByProperties()
                              },
                            },
                            model: {
                              value: _vm.dataSearch.idClass,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataSearch, "idClass", $$v)
                              },
                              expression: "dataSearch.idClass",
                            },
                          },
                          _vm._l(_vm.classList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.className, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.radio === "2"
                ? [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "tdi-form-item",
                        attrs: { label: "Chọn tuần" },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "240px" },
                          attrs: {
                            type: "week",
                            "value-format": "yyyy-MM-dd",
                            format: "Tuần WW(từ dd-MM-yyyy)",
                            placeholder: "Chọn tuần",
                            clearable: false,
                          },
                          on: { change: _vm.getAllClassMenuDetail },
                          model: {
                            value: _vm.timeClassMenu,
                            callback: function ($$v) {
                              _vm.timeClassMenu = $$v
                            },
                            expression: "timeClassMenu",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.getAppTypeUserLogin === "plus"
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "tdi-form-item",
                            attrs: { label: "Chọn khối" },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "160px" },
                                attrs: {
                                  placeholder: "Chọn khối",
                                  clearable: true,
                                },
                                on: { change: _vm.changeGradeDetail },
                                model: {
                                  value: _vm.dataSearch.idGrade,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataSearch, "idGrade", $$v)
                                  },
                                  expression: "dataSearch.idGrade",
                                },
                              },
                              _vm._l(_vm.gradeOfSchoolList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.gradeName,
                                    value: item.id,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "tdi-form-item",
                        attrs: { label: "Chọn lớp" },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "160px" },
                            attrs: {
                              placeholder: "Chọn lớp",
                              clearable: _vm.getAppTypeUserLogin === "plus",
                            },
                            on: { change: _vm.getAllClassMenuDetail },
                            model: {
                              value: _vm.dataSearch.idClass,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataSearch, "idClass", $$v)
                              },
                              expression: "dataSearch.idClass",
                            },
                          },
                          _vm._l(_vm.classList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.className, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.radio === "1",
              expression: "radio === '1'",
            },
          ],
          staticStyle: {
            display: "flex",
            "justify-content": "flex-end",
            "margin-bottom": "12px",
            "padding-right": "16px",
          },
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", plain: "", round: "", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.toggleAllCollapse()
                },
              },
            },
            [
              _c("i", {
                class: _vm.isAllCollapsed
                  ? "el-icon-arrow-down"
                  : "el-icon-arrow-up",
                staticStyle: { "margin-right": "5px" },
              }),
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.isAllCollapsed ? "Mở rộng tất cả" : "Thu gọn tất cả"
                  ) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._l(_vm.tabAllListClassMenu, function (item, index) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.radio === "1",
                expression: "radio === '1'",
              },
            ],
            key: index,
            staticClass: "table-content row-data tdi-table-card",
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                  "align-items": "center",
                  "margin-bottom": "20px",
                  cursor: "pointer",
                },
                on: {
                  click: function ($event) {
                    return _vm.toggleCollapse(index)
                  },
                },
              },
              [
                _c(
                  "h3",
                  {
                    staticStyle: {
                      color: "#2563eb",
                      margin: "0",
                      "font-weight": "bold",
                      "text-transform": "uppercase",
                    },
                  },
                  [
                    _vm._v(
                      "\n        THỰC ĐƠN LỚP: " +
                        _vm._s(item.className) +
                        "\n      "
                    ),
                  ]
                ),
                _c("el-button", {
                  staticStyle: {
                    "font-size": "18px",
                    color: "#2563eb",
                    padding: "0",
                  },
                  attrs: {
                    type: "text",
                    icon: _vm.collapsedMap[index]
                      ? "el-icon-arrow-down"
                      : "el-icon-arrow-up",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-collapse-transition",
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.collapsedMap[index],
                        expression: "!collapsedMap[index]",
                      },
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingData,
                        expression: "loadingData",
                      },
                    ],
                    staticClass: "modern-schedule-table",
                    attrs: {
                      "empty-text": _vm.textTable,
                      "element-loading-text": _vm.$tableLoading,
                      "element-loading-spinner": "el-icon-loading",
                      "element-loading-background": "rgba(255,255,255, 0)",
                      data: item.tabClassMenuList,
                      "highlight-current-row": "",
                      "max-height": _vm.$tableMaxHeight,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "sessionDay",
                        label: "Buổi",
                        align: "center",
                        width: "100",
                        "label-class-name": "pill-header pill-session",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-weight": "700",
                                      color: "#475569",
                                      "font-size": "14px",
                                      "text-transform": "uppercase",
                                      "letter-spacing": "0.5px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(scope.row.sessionDay) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "monday",
                        label: "Thứ 2",
                        align: "center",
                        "label-class-name": "pill-header pill-mon",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "schedule-card",
                                      "card-mon",
                                      {
                                        "has-content":
                                          scope.row.monday ||
                                          scope.row.imgMonday,
                                      },
                                    ],
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "wrap_content_menu",
                                        staticStyle: {
                                          "flex-direction": "column",
                                          "align-items": "center",
                                          width: "100%",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "schedule-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.monday ||
                                                  (!scope.row.imgMonday
                                                    ? "Trống"
                                                    : "")
                                              )
                                            ),
                                          ]
                                        ),
                                        scope.row.imgMonday
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "image_menu_class",
                                                staticStyle: {
                                                  "margin-top": "5px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "image_menu",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handlePreviewImage(
                                                          scope.row.imgMonday
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticStyle: {
                                                        width: "100%",
                                                        height: "100%",
                                                        "object-fit": "cover",
                                                        "border-radius": "4px",
                                                      },
                                                      attrs: {
                                                        src: scope.row
                                                          .imgMonday,
                                                        alt: "",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: "Chỉnh sửa thực đơn Thứ 2",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _vm.getAppTypeUserLogin === "plus"
                                          ? _c("el-button", {
                                              staticClass: "edit-btn-absolute",
                                              attrs: {
                                                size: "mini",
                                                type: "text",
                                                icon: "el-icon-edit",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleEdit(
                                                    scope.$index,
                                                    scope.row,
                                                    2,
                                                    item.className
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "tuesday",
                        label: "Thứ 3",
                        align: "center",
                        "label-class-name": "pill-header pill-tue",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "schedule-card",
                                      "card-tue",
                                      {
                                        "has-content":
                                          scope.row.tuesday ||
                                          scope.row.imgTuesday,
                                      },
                                    ],
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "wrap_content_menu",
                                        staticStyle: {
                                          "flex-direction": "column",
                                          "align-items": "center",
                                          width: "100%",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "schedule-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.tuesday ||
                                                  (!scope.row.imgTuesday
                                                    ? "Trống"
                                                    : "")
                                              )
                                            ),
                                          ]
                                        ),
                                        scope.row.imgTuesday
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "image_menu_class",
                                                staticStyle: {
                                                  "margin-top": "5px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "image_menu",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handlePreviewImage(
                                                          scope.row.imgTuesday
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticStyle: {
                                                        width: "100%",
                                                        height: "100%",
                                                        "object-fit": "cover",
                                                        "border-radius": "4px",
                                                      },
                                                      attrs: {
                                                        src: scope.row
                                                          .imgTuesday,
                                                        alt: "",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: "Chỉnh sửa thực đơn Thứ 3",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _vm.getAppTypeUserLogin === "plus"
                                          ? _c("el-button", {
                                              staticClass: "edit-btn-absolute",
                                              attrs: {
                                                size: "mini",
                                                type: "text",
                                                icon: "el-icon-edit",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleEdit(
                                                    scope.$index,
                                                    scope.row,
                                                    3,
                                                    item.className
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "wednesday",
                        label: "Thứ 4",
                        align: "center",
                        "label-class-name": "pill-header pill-wed",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "schedule-card",
                                      "card-wed",
                                      {
                                        "has-content":
                                          scope.row.wednesday ||
                                          scope.row.imgWednesday,
                                      },
                                    ],
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "wrap_content_menu",
                                        staticStyle: {
                                          "flex-direction": "column",
                                          "align-items": "center",
                                          width: "100%",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "schedule-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.wednesday ||
                                                  (!scope.row.imgWednesday
                                                    ? "Trống"
                                                    : "")
                                              )
                                            ),
                                          ]
                                        ),
                                        scope.row.imgWednesday
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "image_menu_class",
                                                staticStyle: {
                                                  "margin-top": "5px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "image_menu",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handlePreviewImage(
                                                          scope.row.imgWednesday
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticStyle: {
                                                        width: "100%",
                                                        height: "100%",
                                                        "object-fit": "cover",
                                                        "border-radius": "4px",
                                                      },
                                                      attrs: {
                                                        src: scope.row
                                                          .imgWednesday,
                                                        alt: "",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: "Chỉnh sửa thực đơn Thứ 4",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _vm.getAppTypeUserLogin === "plus"
                                          ? _c("el-button", {
                                              staticClass: "edit-btn-absolute",
                                              attrs: {
                                                size: "mini",
                                                type: "text",
                                                icon: "el-icon-edit",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleEdit(
                                                    scope.$index,
                                                    scope.row,
                                                    4,
                                                    item.className
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "thursday",
                        label: "Thứ 5",
                        align: "center",
                        "label-class-name": "pill-header pill-thu",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "schedule-card",
                                      "card-thu",
                                      {
                                        "has-content":
                                          scope.row.thursday ||
                                          scope.row.imgThursday,
                                      },
                                    ],
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "wrap_content_menu",
                                        staticStyle: {
                                          "flex-direction": "column",
                                          "align-items": "center",
                                          width: "100%",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "schedule-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.thursday ||
                                                  (!scope.row.imgThursday
                                                    ? "Trống"
                                                    : "")
                                              )
                                            ),
                                          ]
                                        ),
                                        scope.row.imgThursday
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "image_menu_class",
                                                staticStyle: {
                                                  "margin-top": "5px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "image_menu",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handlePreviewImage(
                                                          scope.row.imgThursday
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticStyle: {
                                                        width: "100%",
                                                        height: "100%",
                                                        "object-fit": "cover",
                                                        "border-radius": "4px",
                                                      },
                                                      attrs: {
                                                        src: scope.row
                                                          .imgThursday,
                                                        alt: "",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: "Chỉnh sửa thực đơn Thứ 5",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _vm.getAppTypeUserLogin === "plus"
                                          ? _c("el-button", {
                                              staticClass: "edit-btn-absolute",
                                              attrs: {
                                                size: "mini",
                                                type: "text",
                                                icon: "el-icon-edit",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleEdit(
                                                    scope.$index,
                                                    scope.row,
                                                    5,
                                                    item.className
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "friday",
                        label: "Thứ 6",
                        align: "center",
                        "label-class-name": "pill-header pill-fri",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "schedule-card",
                                      "card-fri",
                                      {
                                        "has-content":
                                          scope.row.friday ||
                                          scope.row.imgFriday,
                                      },
                                    ],
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "wrap_content_menu",
                                        staticStyle: {
                                          "flex-direction": "column",
                                          "align-items": "center",
                                          width: "100%",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "schedule-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.friday ||
                                                  (!scope.row.imgFriday
                                                    ? "Trống"
                                                    : "")
                                              )
                                            ),
                                          ]
                                        ),
                                        scope.row.imgFriday
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "image_menu_class",
                                                staticStyle: {
                                                  "margin-top": "5px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "image_menu",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handlePreviewImage(
                                                          scope.row.imgFriday
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticStyle: {
                                                        width: "100%",
                                                        height: "100%",
                                                        "object-fit": "cover",
                                                        "border-radius": "4px",
                                                      },
                                                      attrs: {
                                                        src: scope.row
                                                          .imgFriday,
                                                        alt: "",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: "Chỉnh sửa thực đơn Thứ 6",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _vm.getAppTypeUserLogin === "plus"
                                          ? _c("el-button", {
                                              staticClass: "edit-btn-absolute",
                                              attrs: {
                                                size: "mini",
                                                type: "text",
                                                icon: "el-icon-edit",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleEdit(
                                                    scope.$index,
                                                    scope.row,
                                                    6,
                                                    item.className
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    item.morningSaturday ||
                    item.afternoonSaturday ||
                    item.eveningSaturday
                      ? _c("el-table-column", {
                          attrs: {
                            prop: "saturday",
                            label: "Thứ 7",
                            align: "center",
                            "label-class-name": "pill-header pill-sat",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          "schedule-card",
                                          "card-sat",
                                          {
                                            "has-content":
                                              scope.row.saturday ||
                                              scope.row.imgSaturday,
                                          },
                                        ],
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "wrap_content_menu",
                                            staticStyle: {
                                              "flex-direction": "column",
                                              "align-items": "center",
                                              width: "100%",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "schedule-text" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.saturday ||
                                                      (!scope.row.imgSaturday
                                                        ? "Trống"
                                                        : "")
                                                  )
                                                ),
                                              ]
                                            ),
                                            scope.row.imgSaturday
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "image_menu_class",
                                                    staticStyle: {
                                                      "margin-top": "5px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "image_menu",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handlePreviewImage(
                                                              scope.row
                                                                .imgSaturday
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticStyle: {
                                                            width: "100%",
                                                            height: "100%",
                                                            "object-fit":
                                                              "cover",
                                                            "border-radius":
                                                              "4px",
                                                          },
                                                          attrs: {
                                                            src: scope.row
                                                              .imgSaturday,
                                                            alt: "",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content:
                                                "Chỉnh sửa thực đơn Thứ 7",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _vm.getAppTypeUserLogin === "plus"
                                              ? _c("el-button", {
                                                  staticClass:
                                                    "edit-btn-absolute",
                                                  attrs: {
                                                    size: "mini",
                                                    type: "text",
                                                    icon: "el-icon-edit",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleEdit(
                                                        scope.$index,
                                                        scope.row,
                                                        7,
                                                        item.className
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    item.sunday
                      ? _c("el-table-column", {
                          attrs: {
                            prop: "sunday",
                            label: "CN",
                            align: "center",
                            "label-class-name": "pill-header pill-sun",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          "schedule-card",
                                          "card-sun",
                                          {
                                            "has-content":
                                              scope.row.sunday ||
                                              scope.row.imgSunday,
                                          },
                                        ],
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "wrap_content_menu",
                                            staticStyle: {
                                              "flex-direction": "column",
                                              "align-items": "center",
                                              width: "100%",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "schedule-text" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.sunday ||
                                                      (!scope.row.imgSunday
                                                        ? "Trống"
                                                        : "")
                                                  )
                                                ),
                                              ]
                                            ),
                                            scope.row.imgSunday
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "image_menu_class",
                                                    staticStyle: {
                                                      "margin-top": "5px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "image_menu",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handlePreviewImage(
                                                              scope.row
                                                                .imgSunday
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticStyle: {
                                                            width: "100%",
                                                            height: "100%",
                                                            "object-fit":
                                                              "cover",
                                                            "border-radius":
                                                              "4px",
                                                          },
                                                          attrs: {
                                                            src: scope.row
                                                              .imgSunday,
                                                            alt: "",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content:
                                                "Chỉnh sửa thực đơn Chủ nhật",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _vm.getAppTypeUserLogin === "plus"
                                              ? _c("el-button", {
                                                  staticClass:
                                                    "edit-btn-absolute",
                                                  attrs: {
                                                    size: "mini",
                                                    type: "text",
                                                    icon: "el-icon-edit",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleEdit(
                                                        scope.$index,
                                                        scope.row,
                                                        8,
                                                        item.className
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm.radio === "2"
        ? _c(
            "div",
            { staticClass: "table-content row-data tdi-table-card" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingData,
                      expression: "loadingData",
                    },
                  ],
                  staticClass: "modern-detail-table",
                  attrs: {
                    "element-loading-text": _vm.$tableLoading,
                    "element-loading-spinner": "el-icon-loading",
                    "element-loading-background": "rgba(255,255,255, 0)",
                    data: _vm.tabListClassMenuDetail,
                    "highlight-current-row": "",
                    "max-height": _vm.$tableMaxHeight,
                    stripe: "",
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _vm.getAppTypeUserLogin === "plus"
                    ? _c("el-table-column", {
                        attrs: { type: "selection", align: "center" },
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: "STT",
                      align: "center",
                      width: "70px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "gradeName",
                      label: "Tên khối học",
                      align: "center",
                      "min-width": "150px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "className",
                      label: "Tên lớp",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "approve",
                      align: "center",
                      label: "Duyệt",
                      width: "100px",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.listCheckContentDay !== null ||
                              scope.row.fileList != null
                                ? _c("el-checkbox", {
                                    attrs: {
                                      disabled:
                                        _vm.getAppTypeUserLogin !== "plus",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.handleCheckBoxApprove(
                                          scope.$index,
                                          scope.row
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.approve,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "approve", $$v)
                                      },
                                      expression: "scope.row.approve",
                                    },
                                  })
                                : _c("el-checkbox", {
                                    attrs: { disabled: "" },
                                  }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3786133892
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "listCheckContentDay",
                      label: "Các ngày có thực đơn",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.listCheckContentDay) +
                                  "\n          "
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: "Chỉnh sửa nội dung",
                                    placement: "top",
                                  },
                                },
                                [
                                  _vm.getAppTypeUserLogin === "plus"
                                    ? _c("el-button", {
                                        staticClass: "edit-btn-absolute",
                                        attrs: {
                                          size: "mini",
                                          type: "text",
                                          icon: "el-icon-edit",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEditDetailClass(
                                              scope.$index,
                                              scope.row,
                                              2
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      626544577
                    ),
                  }),
                  _vm.getAppTypeUserLogin === "plus"
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "listFileOrPicture",
                          label: "Thực đơn dạng File,Ảnh",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-upload",
                                    {
                                      ref: "upload",
                                      staticClass: "upload-demo",
                                      attrs: {
                                        action: "",
                                        "on-remove": _vm.handleRemove,
                                        "before-remove": _vm.beforeRemove,
                                        "before-upload": _vm.handleBeforeUpload,
                                        multiple: "",
                                        "auto-upload": false,
                                        "on-change": _vm.handleChangeFile,
                                        limit: 5,
                                        "on-exceed": _vm.handleExceed,
                                        "file-list":
                                          scope.row.fileList == null
                                            ? []
                                            : scope.row.fileList,
                                        "on-preview": _vm.handleFileRequest,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: "Nhập file",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _vm.checkPermission([
                                            "studentQuality_menu_update",
                                          ])
                                            ? _c("el-button", {
                                                attrs: {
                                                  size: "mini",
                                                  type: "primary",
                                                  icon: "el-icon-upload2",
                                                  circle: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.getIndexRow(
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1968548233
                        ),
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: { label: "Tác vụ", align: "center", width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "center",
                                    "align-items": "center",
                                    gap: "8px",
                                  },
                                },
                                [
                                  _vm.checkPermission([
                                    "studentQuality_menu_update",
                                  ]) && _vm.getAppTypeUserLogin === "plus"
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: "Lưu File",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("el-button", {
                                            attrs: {
                                              size: "mini",
                                              type: "success",
                                              icon: "el-icon-document-checked",
                                              circle: "",
                                              loading: _vm.loadingButton,
                                              disabled: _vm.checkSave,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleChangeFileMenu()
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: "Xem chi tiết",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                          icon: "el-icon-view",
                                          circle: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleViewDetail(
                                              scope.$index,
                                              scope.row
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      20783776
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "30%",
            visible: _vm.dialogImageClass.isShow,
            "before-close": _vm.handleCloseDialogImageClass,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialogImageClass, "isShow", $event)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                "margin-top": "20px",
              },
            },
            [
              _vm.dialogImageClass.imageUrl !== ""
                ? _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      src: _vm.dialogImageClass.imageUrl,
                      alt: "Ảnh thực đơn",
                    },
                  })
                : _vm._e(),
            ]
          ),
        ]
      ),
      _c("UpdateClassMenu", {
        ref: "UpdateClassMenu",
        attrs: { dialogVisible: _vm.showUpdateDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseUpdateMethod()
          },
        },
      }),
      _c("CreateClassMenu", {
        ref: "CreateClassMenu",
        attrs: { dialogVisible: _vm.showCreateDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseCreateMethod()
          },
        },
      }),
      _c("CreateClassMenuExcel", {
        ref: "CreateClassMenuExcel",
        attrs: { dialogVisibleEx: _vm.showCreateExDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseCreateExMethod()
          },
        },
      }),
      _c("CreateClassMenuFile", {
        ref: "CreateClassMenuFile",
        attrs: { dialogVisibleFile: _vm.showCreateFileDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseCreateFileMethod()
          },
        },
      }),
      _c("ClassMenuDetail", {
        ref: "ClassMenuDetail",
        attrs: { dialogVisible: _vm.showViewDetailDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseViewDetailMethod()
          },
        },
      }),
      _c("ExportExcelStatisticsDialog", {
        attrs: {
          showExportExcelStatistics: _vm.showExportExcelStatistics,
          listClass: _vm.classListCommon,
        },
        on: {
          close: function ($event) {
            return _vm.handleCloseExportExcelStatistics()
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "tdi-card-title" }, [_vm._v("Quản lý thực đơn")]),
      _c("p", { staticClass: "tdi-card-subtitle" }, [
        _vm._v("Tra cứu và quản lý thực đơn của học sinh"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }